<template>
  <div class="page_win bindPhoneWin">
    <div class="topContent">
      <div class="topContent_l" @click="back">
        <img :src="returnRightImg" alt="" />
      </div>
      <div class="topContent_m">
        <span>绑定手机</span>
      </div>
      <div class="closeBtn" @click="close">
        <img :src="closeImg" />
      </div>
    </div>
    <div class="bottomContent">
      <div class="view_group">
        <div class="view_group_l">
          <img :src="phoneImg" class="phone_icon" alt="" />
          <input
            class="codeInput"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
            placeholder-style="color:#999"
            type="text"
            maxlength="11"
            name="bindMobile"
            v-model="bindMobile"
            placeholder="请输入手机号码"
            autocomplete="off"
          />
        </div>
         
      </div>
      <div class="view_group">
        <div class="view_group_l">
          <img :src="codeImg" class="code_icon" alt="" />
          <input
            class="codeInput"
            maxlength="6"
            placeholder-style="color:#999"
            type="text"
            name="bindCode"
            v-model="bindCode"
            placeholder="请输入验证码"
            autocomplete="off"
          />
        </div>
        <div
          class="getcodeAll selectColor"
          @click="getCodeBind"
          :disabled="countdownBind < 60 && countdownBind >= 1"
        >
          {{
              countdownBind &lt; 60 && countdownBind >= 1
                ? `${countdownBind}秒后可重发`
                : "获取验证码"
          }}
        </div>
      </div>
    </div>
    <div class="bot_btn" @click="bindUserPhone">立即绑定手机</div>
  </div>
</template>

<script>
import { hex_md5 } from "@/common/js/md5.js";
import fun from "@/common/js/common.js";

export default {
  name: "bindPhone",
  inject: ["reload"], //注入App里的reload方法
  data() {
    return {
      bindMobile: "", //手机号码
      bindCode: "", //验证码
      countdownBind: 60,

      userInfo: {
        uid: null,
      }, //用户资料
      adid: "", // 广告id
      uid: "",
      returnRightImg: require("../../assets/img/view10/back.png"),
      closeImg: require("../../assets/img/view10/close.png"), // 关闭
      close_icon2: require("../../assets/img/view10/close2.png"), // 关闭
      phoneImg: require("../../assets/img/view10/phone.png"), // 手机号
      codeImg: require("../../assets/img/view10/code.png"),
    };
  },
  created() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.uid = this.userInfo.uid;
    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");
  },
  methods: {
    back() {
      this.$store.dispatch("IsBindPhoneFun", false);
      this.$store.dispatch("IsUserInfoMaskFun", true);
    },
    close() {
      this.$store.dispatch("IsBindPhoneFun", false);
      // this.$store.dispatch("IsUserInfoMaskFun", false);
    },
    // 绑定手机
    bindUserPhone() {
      if (!this.bindMobile) {
        this.$toast.text("请输入手机号");
        return false;
      }
      if (!/^1(3|4|5|7|8|9)\d{9}$/.test(this.bindMobile)) {
        this.$toast.text("手机号码有误，请重新输入");
        return false;
      }
      if (!this.bindCode) {
        this.$toast.text("请输入验证码");
        return false;
      }
      this.time = new Date().getTime();
      this.sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + this.time
      );
      let data = {
        uid: this.uid,
        adid: this.adid,
        sign: this.sign,
        time: this.time,
        phone: this.bindMobile,
        code: this.bindCode,
        reg_type: "1",
        os: this.$store.state.deviceData.os,
      };
      this.$store.commit("postIsBindPhone", "1");
      localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.$http.post(fun.apiUrl + "api/member/bind_phone_code", data).then(
        function (res) {
          if (res.body.code === 200) {
            this.$store.dispatch("IsBindPhoneFun", false);
            this.userInfo.bindPhone = "1";
            this.$store.commit("postIsBindPhone", "1");
            this.$toast.text(res.body.msg);
            localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {}
      );
    },
    // 获取验证码
    getCodeBind() {
      if (!this.bindMobile) {
        this.$toast.text("请输入手机号");
        return false;
      }
      if (!/^1(3|4|5|7|8|9)\d{9}$/.test(this.bindMobile)) {
        this.$toast.text("手机号码有误，请重新输入");
        return false;
      }
      // 发送验证码
      if (this.countdownBind < 60 && this.countdownBind >= 1) {
        return;
      }
      this.time = new Date().getTime();
      this.sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + this.time
      );
      let data = {
        adid: this.adid,
        sign: this.sign,
        time: this.time,
        os: this.$store.state.deviceData.os,
        phone: this.bindMobile,
      };

      this.$http.post(fun.apiUrl + "api/member/code", data).then(
        function (res) {
          this.countDownBind();
        },
        function (res) {}
      );
    },
    // 倒计时
    countDownBind() {
      if (this.countdownBind < 60 && this.countdownBind >= 1) {
        return;
      }

      let self = this;
      self.countdownBind = 60;
      self.countdownBind -= 1;
      if (self.clear) {
        clearInterval(self.clear);
      }
      self.clear = null;
      self.clear = setInterval((_) => {
        if (self.countdownBind > 0) {
          self.countdownBind -= 1;
        } else {
          clearInterval(self.clear);
        }
      }, 1000);
    },
  },
};
</script>

<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
input {
  outline: none;
  border: none;
  background-color: transparent !important;
  color: #aaa8a8;
}
::-webkit-input-placeholder {
  color: #aaa8a8;
}
::-moz-placeholder {
  color: #aaa8a8;
} /* firefox 19+ */
:-ms-input-placeholder {
  color: #aaa8a8;
} /* ie */
input:-moz-placeholder {
  color: #aaa8a8;
}

.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
}
.topContent_l,
.topContent_m,
.closeBtn {
  @include flex_box(row, center, center);
}
.topContent_l,
.closeBtn {
  position: absolute;
  top: 0;
  height: 0.68rem;
  width: 0.8rem;
}
.topContent_l {
  left: 0;
  justify-content: flex-start;
  img {
    width: 0.24rem;
    height: auto;
  }
}
.closeBtn {
  right: 0;
  justify-content: flex-end;
  img {
    width: 0.3rem;
  }
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #12CDB0;
    line-height: 0.68rem;
  }
}

.bottomContent {
  @include flex_box(column, none, stretch);
}
.view_group {
  position: relative;
 margin-top: 0.34rem;
  @include flex_box(row, space-between, center);
}
.view_group_l{
  border: 1px solid #12CDB0;
 padding: 0 0.22rem;
  border-radius: 0.1rem;
  
  height: 0.8rem;
box-sizing: border-box;
}

.getcodeAll {
  margin-left: .3rem;
  height: 0.8rem;
  background: #12CDB0;
  color: #ffffff;
  border-radius: 0.1rem;
  font-size: 0.22rem;
  padding: 0 0.16rem;
  @include flex_box(row, center, center);
}
</style>



// WEBPACK FOOTER //
// src/views/view10/bindPhone.vue